// @ts-nocheck

import { cx } from '@emotion/css';
import React from 'react';
export function withClassName(SelectComponent: any, className: string, extra?: (props: any) => any): any {
  return (props: any) => <SelectComponent {...props} className={cx(props.className, className, extra && extra(props))} />;
}
export function withClassNameToInnerProps(SelectComponent: any, className: string) {
  return (props: any) => (
    <SelectComponent
      {...props}
      innerProps={{
        ...(props.innerProps || {}),
        className: cx(props.innerProps && props.innerProps.className, props.className, className),
      }}
    />
  );
}
